import * as ActionTypes from '../../actions/allActions'

const initialState = { form_errors: {} }
const residences = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.BACKEND_FORM_ERROR:
			return { ...state, form_errors: action.form_errors }
		case ActionTypes.LOGOUT:
			return initialState
		default:
			return state
	}
}

export default residences


// WEBPACK FOOTER //
// ./src/reducers/metadata/residences.js